import * as Immutable from "immutable";
import { JAVASCRIPT_EVENT_NAME_CHAR_LIMIT } from "constants/messages";
import BaseMessageRecord from "../BaseMessageRecord";

class JavascriptEventMessageRecord extends BaseMessageRecord({
  type: "custom_javascript_event",
  eventName: ""
}) {}

/**
 * Validation
 */

/**
 * @param {LinkMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
JavascriptEventMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();
  const { eventName } = message;
  const eventNameCleaned = message.eventName.replace(/ /g, "");

  if (
    eventNameCleaned !== eventName ||
    eventNameCleaned.length <= 0 ||
    eventNameCleaned.length > JAVASCRIPT_EVENT_NAME_CHAR_LIMIT
  ) {
    invalidFields.add("eventName");
  }

  return Immutable.List(invalidFields);
};

export default JavascriptEventMessageRecord;
